import React from "react";

function SubHeader({ title, description, children }) {
  return (
     <div className="py-3 py-lg-4 border-bottom bg-light">
      <div className="container-xxl d-flex justify-content-between flex-md-row flex-column">
        <div className="d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 className="h3 text-dark fw-bold d-flex flex-column justify-content-center my-0">
            {title && title}
          </h1>
          <span className="text-muted fw-medium small my-0 pt-1">
            {description && description}
          </span>
        </div>
        {children}
      </div>
    </div>
  );
}

export default SubHeader;
